import axios from 'axios'
import * as PusherPushNotifications from "@pusher/push-notifications-web";
const AUTH_TOKEN_KEY = 'authToken'

export default {
    // Get full user info
    async fetchUser(token) {
        axios.defaults.headers.common = {'Authorization': `Bearer ${this.getAuthToken()}`}
        if (this.isLoggedIn()) {
            return await axios.post('/user/current', token)
                .then((r)=>{
                    localStorage.setItem('user',JSON.stringify(r.data))
                })
                .catch((e) => {
                    // eslint-disable-next-line
                    console.log(e)
                })
        }
    },

    getUserInfo() {
        if (this.isLoggedIn()) {
            return this.decode(this.getAuthToken())
        }
    },
    isLoggedIn() {
        let authToken = this.getAuthToken()
        return !!authToken && !this.isTokenExpired(authToken)
    },
    getAuthToken() {
        return localStorage.getItem(AUTH_TOKEN_KEY)
    },

    isTokenExpired(token) {
        let expirationDate = this.getTokenExpirationDate(token)
        return expirationDate < new Date()
    },
    getTokenExpirationDate(encodedToken) {
        let token = this.decode(encodedToken)
        if (!token.exp) {
            return null
        }

        let date = new Date(0)
        date.setUTCSeconds(token.exp)

        return date
    },

    logoutUser() {
        const beamsClient = new PusherPushNotifications.Client({
            instanceId: '5a8b4674-0e25-42bb-bd32-fc0291ade48a'
        })
        beamsClient.stop()
        this.clearAuthToken()
    },
    clearAuthToken() {
        //axios.defaults.headers.common['Authorization'] = ''
        localStorage.removeItem(AUTH_TOKEN_KEY)
    },
    setAuthToken(token) {
        localStorage.setItem(AUTH_TOKEN_KEY, token)
    },
    decode(token){
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return  JSON.parse(jsonPayload);
    }

};
